import { createFileRoute } from '@tanstack/react-router';

import { loadWalletMessages, loadWalletScreens, walletDetailScreen, walletDetailSearch } from '@/modules/wallet/route';
import { lazyScreen } from '@/shared/screen';

// Detalhe da carteira (`router.tsx:1362-1366`); as abas do legado viram `?tab=` (S29).
export const Route = createFileRoute('/_app/gestao-carteira/carteiras/$walletId/')({
  validateSearch: walletDetailSearch,
  staticData: { screen: walletDetailScreen },
  loader: loadWalletMessages,
  component: lazyScreen(loadWalletScreens, 'WalletDetailScreen'),
});
